import axios from "axios";

export const apiUpdateAuthZero = async (id, value) => {
  try {
    const result = await axios
      .patch(`/api/profile/${id}`, {
        blocked: value,
      })
      .then(function (response) {
        const { data } = response;
        // console.log(data);
        return data;
      });
    return result;
  } catch (error) {
    console.log("error apiUpdateAuthZero");
    console.log(error);
    return {};
  }
};

export const apiGetMemberOf = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/auth/member-of/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetMemberOf");
    return null;
  }
};

export const apiGetAdmins = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/auth/admins/${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetMemberOf");
    return null;
  }
};

export const apiGenerateCode = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/room/code`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGenerateCode");
    return null;
  }
};

export const apiVerifyCode = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/room/verify`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    return null;
  }
};

export const apiGetMember = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(`${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/${id}`, config)
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetMember");
    return null;
  }
};

export const apiGetAvailMembers = async (client, board) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/add-board/${board}?client=${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetAvailMembers");
    return null;
  }
};

export const apiGetLanding = async (client, user) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/landing/home?client=${client}&user=${user}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiGetLanding");
    console.error(error);
    return null;
  }
};

export const apiGetAssigned = async (user, client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/landing/assigned/${user}?client=${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiGetLanding");
    console.error(error);
    return null;
  }
};

export const apiGetUserList = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/client-list/${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiGetUserList");
    console.error(error);
    return null;
  }
};

export const apiLoginUser = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/login`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiLoginUser");
    return null;
  }
};

export const apiUpdateUser = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/update/${id}`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api user apiUpdateUser");
    return null;
  }
};

export const apiUpdateUserBoards = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/board/${id}`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api user apiUpdateUserBoards");
    return null;
  }
};

export const apiUpdateUserTeams = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/teams/${id}`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api user apiUpdateUserTeams");
    return null;
  }
};

export const apiGetSetupUserList = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/setup-list/${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetSetupUserList");
    return null;
  }
};

export const apiGetSetupUser = async (user) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/setup/${user}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetSetupUserList");
    return null;
  }
};

export const apiUpdateMemberOfList = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/memberOf`,
        data,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api user apiUpdateMemberOfList");
    return null;
  }
};

export const apiGetBoardLanding = async (client, user) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/landing/board?client=${client}&user=${user}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiGetBoardLanding");
    console.error(error);
    return null;
  }
};

export const apiGetAllUsers = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/all/${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiGetUserList");
    console.error(error);
    return null;
  }
};

export const apiGetUserSignature = async (user) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/sign/user/${user}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiGetUserSignature");
    console.error(error);
    return null;
  }
};

export const apiUpdateUserSignature = async (user, signature, client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/sign/user/${user}`,
        { signature, client },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiUpdateUserSignature");
    console.error(error);
    return null;
  }
};

export const apiGetClientSignatures = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/sign/all/${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiGetUserSignature");
    console.error(error);
    return null;
  }
};

export const apiCreateNewUser = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/new`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error(error);
    console.log("error api user apiCreateNewUser");
    return null;
  }
};

export const apiGetViewerLanding = async (client, user) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/landing/viewer?client=${client}&user=${user}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiGetViewerLanding");
    console.error(error);
    return null;
  }
};

export const apiVerifyEmail = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/email`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiVerifyEmail");
    console.error(error);
    return null;
  }
};

export const apiUpdateStars = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/stars/update`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api user apiUpdateStars");
    console.error(error);
    return null;
  }
};
